<template>
  <b-modal
    centered
    v-model="showModal"
    size="xl"
    scrollable
    :title="title"
    @hidden="$emit('close')"
  >
    <div class="show-document-content mt-5 pt-3" v-html="content"></div>
    <template #modal-footer="{ cancel }">
      <button class="btn g-primary-button" @click="cancel()">
        {{ $t("property.closeGallery") }}
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "DocumentModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      default: "",
    },
  },
  computed: {
    showModal: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
};
</script>

<style>
.show-document-content {
  max-height: 60vh;
  overflow-y: auto;
  white-space: normal;
}
</style>
